import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "flex justify-center items-center py-8" }
const _hoisted_2 = { class: "w-full max-w-md flex items-center flex-col space-y-6 px-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "text-2xl text-gray-700 font-ammocorps flex items-center" }, " Deposit Funds ", -1)
const _hoisted_4 = { class: "mb-2 text-sm flex justify-center" }
const _hoisted_5 = { class: "w-full" }
const _hoisted_6 = { class: "mb-2 text-sm flex justify-between" }
const _hoisted_7 = { class: "mt-1" }
const _hoisted_8 = ["disabled", "max"]
const _hoisted_9 = { class: "w-12/12" }
const _hoisted_10 = { class: "mb-2 text-sm flex justify-between items-center" }
const _hoisted_11 = {
  key: 1,
  class: "text-gray-400 flex items-center"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h1", null, "Add Card", -1)
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = {
  key: 0,
  class: "mt-2 flex items-center w-full justify-end"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "mr-2" }, "CVV", -1)
const _hoisted_17 = ["disabled", "max"]
const _hoisted_18 = { class: "py-1" }
const _hoisted_19 = {
  href: "#",
  class: "block px-4 py-2 text-sm w-full flex justify-between"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("h1", { class: "ml-4" }, "Add Credit or Debit Card", -1)
const _hoisted_21 = { class: "flex items-center justify-center min-h-screen pt-4 px-4 text-center sm:block sm:p-0" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", {
  class: "hidden sm:inline-block sm:align-middle sm:h-screen",
  "aria-hidden": "true"
}, "​", -1)
const _hoisted_23 = { class: "p-4 inline-block align-bottom bg-white border border-slate-400 rounded-lg w-full md:max-w-xl text-left overflow-hidden transform transition-all sm:align-middle" }
const _hoisted_24 = { class: "inline-block align-bottom bg-white rounded-lg w-full text-left overflow-hidden transform transition-all sm:align-middle" }
const _hoisted_25 = { class: "" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-3xl text-slate-800 mt-2 font-ammocorps text-center" }, "Add New Card ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CreditCardIcon = _resolveComponent("CreditCardIcon")!
  const _component_ChevronDownIcon = _resolveComponent("ChevronDownIcon")!
  const _component_MenuButton = _resolveComponent("MenuButton")!
  const _component_MenuItem = _resolveComponent("MenuItem")!
  const _component_MenuItems = _resolveComponent("MenuItems")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_DialogOverlay = _resolveComponent("DialogOverlay")!
  const _component_TransitionChild = _resolveComponent("TransitionChild")!
  const _component_CreditCardForm = _resolveComponent("CreditCardForm")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_TransitionRoot = _resolveComponent("TransitionRoot")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("h1", _hoisted_4, [
        (_ctx.FormStatus.message.length > 0)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass({
              'text-gray-400': _ctx.FormStatus.color == 'gray',
              'text-red-400': _ctx.FormStatus.color == 'red',
            })
            }, _toDisplayString(_ctx.FormStatus.message), 3))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h1", _hoisted_6, [
          _createTextVNode(" Amount: "),
          (_ctx.AmountStatus.message.length > 0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass({
                  'text-gray-400': _ctx.AmountStatus.color == 'gray',
                  'text-red-400': _ctx.AmountStatus.color == 'red',
                })
              }, _toDisplayString(_ctx.AmountStatus.message), 3))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _withDirectives(_createElementVNode("input", {
            disabled: _ctx.loading,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.amount) = $event)),
            "value:v-bind": "amount",
            onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.validateAmount && _ctx.validateAmount(...args))),
            type: "number",
            min: "0",
            max: _ctx.maxDeposit,
            name: "amount",
            id: "amount",
            class: "focus:ring-gray-400 focus:border-gray-400 block w-full sm:text-sm border-black text-left",
            placeholder: "$0"
          }, null, 40, _hoisted_8), [
            [_vModelText, _ctx.amount]
          ])
        ])
      ]),
      _createVNode(_component_Menu, {
        as: "div",
        class: "relative w-full inline-block text-left"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("h1", _hoisted_10, [
              _createTextVNode(" Source: "),
              (_ctx.AccountStatus.message.length > 0 && _ctx.AccountStatus.message !== 'No Sources Found')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass({
                      'text-gray-400': _ctx.AccountStatus.color == 'gray',
                      'text-red-400': _ctx.AccountStatus.color == 'red',
                    })
                  }, _toDisplayString(_ctx.AccountStatus.message), 3))
                : (_ctx.AccountStatus.message == 'No Sources Found')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createTextVNode(" No Sources Found "),
                      _createElementVNode("button", {
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addNewCard && _ctx.addNewCard(...args))),
                        class: "ml-2 px-2 flex items-center text-sm border rounded border-indigo-500 hover:border-indigo-300 text-indigo-500 hover:text-indigo-300"
                      }, [
                        _createVNode(_component_CreditCardIcon, {
                          class: "h-7 py-[3px] pr-2",
                          "aria-hidden": "true"
                        }),
                        _hoisted_12
                      ])
                    ]))
                  : _createCommentVNode("", true)
            ]),
            _createVNode(_component_MenuButton, {
              disabled: _ctx.loading,
              class: "inline-flex justify-between w-full rounded border border-slate-400 shadow-sm px-4 py-2 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-gray-400"
            }, {
              default: _withCtx(() => [
                (_ctx.activeAccount)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.activeAccount.descriptor + " **** " + _ctx.activeAccount.nickName), 1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_14, "Select Account")),
                _createVNode(_component_ChevronDownIcon, {
                  class: "-mr-1 ml-2 h-5 w-5",
                  "aria-hidden": "true"
                })
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          (_ctx.activeAccount && _ctx.activeAccount.descriptor == 'Card2')
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _hoisted_16,
                _withDirectives(_createElementVNode("input", {
                  disabled: _ctx.loading,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.cvcInput) = $event)),
                  type: "number",
                  min: "0",
                  max: _ctx.maxDeposit,
                  name: "cvv",
                  id: "cvv",
                  class: "focus:ring-gray-400 focus:border-indigo-500 block rounded sm:text-sm border-slate-500 text-left",
                  placeholder: "000"
                }, null, 8, _hoisted_17), [
                  [_vModelText, _ctx.cvcInput]
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode(_Transition, {
            "enter-active-class": "transition ease-out duration-100",
            "enter-from-class": "transform opacity-0 scale-95",
            "enter-to-class": "transform opacity-100 scale-100",
            "leave-active-class": "transition ease-in duration-75",
            "leave-from-class": "transform opacity-100 scale-100",
            "leave-to-class": "transform opacity-0 scale-95"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_MenuItems, { class: "origin-top-left absolute left-0 mt-2 w-full rounded-md shadow-lg bg-white ring-1 ring-slate-300 focus:outline-none" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_18, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paymentMethods, (paymentMethod) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: paymentMethod.id
                      }, [
                        _createVNode(_component_MenuItem, {
                          onClick: ($event: any) => (_ctx.selectAccount(paymentMethod))
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("a", _hoisted_19, [
                              _createElementVNode("h1", null, _toDisplayString(paymentMethod.descriptor), 1),
                              _createElementVNode("h1", null, "**** " + _toDisplayString(paymentMethod.nickName), 1)
                            ])
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]))
                    }), 128)),
                    _createVNode(_component_MenuItem, { onClick: _ctx.addNewCard }, {
                      default: _withCtx(({ active }) => [
                        _createElementVNode("a", {
                          href: "#",
                          class: _normalizeClass([ active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'pl-4 h-12 flex items-center text-sm border-t w-full', ])
                        }, [
                          _createVNode(_component_CreditCardIcon, {
                            class: "h-7 w-7 fill-gray-700 border border-black border-3 rounded-full p-1",
                            "aria-hidden": "true"
                          }),
                          _hoisted_20
                        ], 2)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("button", {
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.pay && _ctx.pay(...args))),
        class: "w-full border-gray-500 hover:border-gray-700 text-slate-500 hover:text-slate-700 border px-5 py-2 rounded"
      }, _toDisplayString(_ctx.loading ? "Sending..." : "Initiate Transfer"), 1)
    ]),
    _createVNode(_component_TransitionRoot, {
      as: "template",
      show: _ctx.cardFormIsOpen
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Dialog, {
          as: "div",
          class: "fixed z-50 inset-0 overflow-y-auto w-full",
          onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.cardFormIsOpen = false))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_21, [
              _createVNode(_component_TransitionChild, {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0",
                "enter-to": "opacity-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100",
                "leave-to": "opacity-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DialogOverlay, { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" })
                ]),
                _: 1
              }),
              _hoisted_22,
              _createVNode(_component_TransitionChild, {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _hoisted_26,
                        _createElementVNode("div", null, [
                          _createVNode(_component_CreditCardForm, {
                            memberId: _ctx.memberId ? _ctx.memberId : null
                          }, null, 8, ["memberId"])
                        ])
                      ])
                    ])
                  ])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}